import type { DepositRegistration } from '@/types/database/depositRegistration';

export const showName = (item: DepositRegistration) => {
  const { type, peopleName, household, recipient } = item;

  if (type === '寄件') {
    return peopleName;
  } else {
    return recipient !== '' ? recipient : household;
  }
};
